/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnswerTo } from '../models/answer-to';
import { apiWebAnkietyNiepodpisanaPost } from '../fn/operations/api-web-ankiety-niepodpisana-post';
import { ApiWebAnkietyNiepodpisanaPost$Params } from '../fn/operations/api-web-ankiety-niepodpisana-post';
import { apiWebAnkietyPodpisanaPost } from '../fn/operations/api-web-ankiety-podpisana-post';
import { ApiWebAnkietyPodpisanaPost$Params } from '../fn/operations/api-web-ankiety-podpisana-post';
import { apiWebCzyIdentyfikatorKorektyWolnyGet } from '../fn/operations/api-web-czy-identyfikator-korekty-wolny-get';
import { ApiWebCzyIdentyfikatorKorektyWolnyGet$Params } from '../fn/operations/api-web-czy-identyfikator-korekty-wolny-get';
import { apiWebCzyIdentyfikatorTrWolnyGet } from '../fn/operations/api-web-czy-identyfikator-tr-wolny-get';
import { ApiWebCzyIdentyfikatorTrWolnyGet$Params } from '../fn/operations/api-web-czy-identyfikator-tr-wolny-get';
import { apiWebCzyIdentyfikatorTrZarejestrowanyGet } from '../fn/operations/api-web-czy-identyfikator-tr-zarejestrowany-get';
import { ApiWebCzyIdentyfikatorTrZarejestrowanyGet$Params } from '../fn/operations/api-web-czy-identyfikator-tr-zarejestrowany-get';
import { apiWebCzyInstytucjaNieZarejestrowanaGet } from '../fn/operations/api-web-czy-instytucja-nie-zarejestrowana-get';
import { ApiWebCzyInstytucjaNieZarejestrowanaGet$Params } from '../fn/operations/api-web-czy-instytucja-nie-zarejestrowana-get';
import { apiWebCzyInstytucjaZarejestrowanaGet } from '../fn/operations/api-web-czy-instytucja-zarejestrowana-get';
import { ApiWebCzyInstytucjaZarejestrowanaGet$Params } from '../fn/operations/api-web-czy-instytucja-zarejestrowana-get';
import { apiWebCzyUnikalnaNazwaInstytucjiGet } from '../fn/operations/api-web-czy-unikalna-nazwa-instytucji-get';
import { ApiWebCzyUnikalnaNazwaInstytucjiGet$Params } from '../fn/operations/api-web-czy-unikalna-nazwa-instytucji-get';
import { apiWebFaqGet } from '../fn/operations/api-web-faq-get';
import { ApiWebFaqGet$Params } from '../fn/operations/api-web-faq-get';
import { apiWebFaqKategorieGet } from '../fn/operations/api-web-faq-kategorie-get';
import { ApiWebFaqKategorieGet$Params } from '../fn/operations/api-web-faq-kategorie-get';
import { apiWebHealthGet } from '../fn/operations/api-web-health-get';
import { ApiWebHealthGet$Params } from '../fn/operations/api-web-health-get';
import { apiWebHealthLiveGet } from '../fn/operations/api-web-health-live-get';
import { ApiWebHealthLiveGet$Params } from '../fn/operations/api-web-health-live-get';
import { apiWebHealthReadyGet } from '../fn/operations/api-web-health-ready-get';
import { ApiWebHealthReadyGet$Params } from '../fn/operations/api-web-health-ready-get';
import { apiWebHealthStartedGet } from '../fn/operations/api-web-health-started-get';
import { ApiWebHealthStartedGet$Params } from '../fn/operations/api-web-health-started-get';
import { apiWebInstytucjeGet$Json } from '../fn/operations/api-web-instytucje-get-json';
import { ApiWebInstytucjeGet$Json$Params } from '../fn/operations/api-web-instytucje-get-json';
import { apiWebInstytucjeGet$Xml } from '../fn/operations/api-web-instytucje-get-xml';
import { ApiWebInstytucjeGet$Xml$Params } from '../fn/operations/api-web-instytucje-get-xml';
import { apiWebInstytucjeNipCertyfikatyGet } from '../fn/operations/api-web-instytucje-nip-certyfikaty-get';
import { ApiWebInstytucjeNipCertyfikatyGet$Params } from '../fn/operations/api-web-instytucje-nip-certyfikaty-get';
import { apiWebInstytucjeNipCertyfikatyPost } from '../fn/operations/api-web-instytucje-nip-certyfikaty-post';
import { ApiWebInstytucjeNipCertyfikatyPost$Params } from '../fn/operations/api-web-instytucje-nip-certyfikaty-post';
import { apiWebInstytucjeNipGet$Json } from '../fn/operations/api-web-instytucje-nip-get-json';
import { ApiWebInstytucjeNipGet$Json$Params } from '../fn/operations/api-web-instytucje-nip-get-json';
import { apiWebInstytucjeNipGet$Xml } from '../fn/operations/api-web-instytucje-nip-get-xml';
import { ApiWebInstytucjeNipGet$Xml$Params } from '../fn/operations/api-web-instytucje-nip-get-xml';
import { apiWebInstytucjeNipHistoriaGet$Json } from '../fn/operations/api-web-instytucje-nip-historia-get-json';
import { ApiWebInstytucjeNipHistoriaGet$Json$Params } from '../fn/operations/api-web-instytucje-nip-historia-get-json';
import { apiWebInstytucjeNipHistoriaGet$Xml } from '../fn/operations/api-web-instytucje-nip-historia-get-xml';
import { ApiWebInstytucjeNipHistoriaGet$Xml$Params } from '../fn/operations/api-web-instytucje-nip-historia-get-xml';
import { apiWebInstytucjeNipHistoriaZioIdGet$Json } from '../fn/operations/api-web-instytucje-nip-historia-zio-id-get-json';
import { ApiWebInstytucjeNipHistoriaZioIdGet$Json$Params } from '../fn/operations/api-web-instytucje-nip-historia-zio-id-get-json';
import { apiWebInstytucjeNipHistoriaZioIdGet$Xml } from '../fn/operations/api-web-instytucje-nip-historia-zio-id-get-xml';
import { ApiWebInstytucjeNipHistoriaZioIdGet$Xml$Params } from '../fn/operations/api-web-instytucje-nip-historia-zio-id-get-xml';
import { apiWebInstytucjeNipKomunikatyGet } from '../fn/operations/api-web-instytucje-nip-komunikaty-get';
import { ApiWebInstytucjeNipKomunikatyGet$Params } from '../fn/operations/api-web-instytucje-nip-komunikaty-get';
import { apiWebInstytucjeNipKomunikatyIdZalacznikGet } from '../fn/operations/api-web-instytucje-nip-komunikaty-id-zalacznik-get';
import { ApiWebInstytucjeNipKomunikatyIdZalacznikGet$Params } from '../fn/operations/api-web-instytucje-nip-komunikaty-id-zalacznik-get';
import { apiWebInstytucjeNipPlikiGet$Json } from '../fn/operations/api-web-instytucje-nip-pliki-get-json';
import { ApiWebInstytucjeNipPlikiGet$Json$Params } from '../fn/operations/api-web-instytucje-nip-pliki-get-json';
import { apiWebInstytucjeNipPlikiGet$Xml } from '../fn/operations/api-web-instytucje-nip-pliki-get-xml';
import { ApiWebInstytucjeNipPlikiGet$Xml$Params } from '../fn/operations/api-web-instytucje-nip-pliki-get-xml';
import { apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf } from '../fn/operations/api-web-instytucje-nip-pliki-niezaszyfrowany-post-pdf';
import { ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Params } from '../fn/operations/api-web-instytucje-nip-pliki-niezaszyfrowany-post-pdf';
import { apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip } from '../fn/operations/api-web-instytucje-nip-pliki-niezaszyfrowany-post-zip';
import { ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip$Params } from '../fn/operations/api-web-instytucje-nip-pliki-niezaszyfrowany-post-zip';
import { apiWebInstytucjeNipPlikiPlzIdGet$Json } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-get-json';
import { ApiWebInstytucjeNipPlikiPlzIdGet$Json$Params } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-get-json';
import { apiWebInstytucjeNipPlikiPlzIdGet$Xml } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-get-xml';
import { ApiWebInstytucjeNipPlikiPlzIdGet$Xml$Params } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-get-xml';
import { apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-identyfikatory-get-json';
import { ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Params } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-identyfikatory-get-json';
import { apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-identyfikatory-get-xml';
import { ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml$Params } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-identyfikatory-get-xml';
import { apiWebInstytucjeNipPlikiPlzIdUpoGet } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-upo-get';
import { ApiWebInstytucjeNipPlikiPlzIdUpoGet$Params } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-upo-get';
import { apiWebInstytucjeNipPlikiPlzIdUpoPdfGet } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-upo-pdf-get';
import { ApiWebInstytucjeNipPlikiPlzIdUpoPdfGet$Params } from '../fn/operations/api-web-instytucje-nip-pliki-plz-id-upo-pdf-get';
import { apiWebInstytucjeNipPlikiPost } from '../fn/operations/api-web-instytucje-nip-pliki-post';
import { ApiWebInstytucjeNipPlikiPost$Params } from '../fn/operations/api-web-instytucje-nip-pliki-post';
import { apiWebInstytucjeNipPut } from '../fn/operations/api-web-instytucje-nip-put';
import { ApiWebInstytucjeNipPut$Params } from '../fn/operations/api-web-instytucje-nip-put';
import { apiWebInstytucjeNipRoboczeGet } from '../fn/operations/api-web-instytucje-nip-robocze-get';
import { ApiWebInstytucjeNipRoboczeGet$Params } from '../fn/operations/api-web-instytucje-nip-robocze-get';
import { apiWebInstytucjeNipRoboczeKrbIdDelete } from '../fn/operations/api-web-instytucje-nip-robocze-krb-id-delete';
import { ApiWebInstytucjeNipRoboczeKrbIdDelete$Params } from '../fn/operations/api-web-instytucje-nip-robocze-krb-id-delete';
import { apiWebInstytucjeNipRoboczeKrbIdGet } from '../fn/operations/api-web-instytucje-nip-robocze-krb-id-get';
import { ApiWebInstytucjeNipRoboczeKrbIdGet$Params } from '../fn/operations/api-web-instytucje-nip-robocze-krb-id-get';
import { apiWebInstytucjeNipRoboczeKrbIdPut } from '../fn/operations/api-web-instytucje-nip-robocze-krb-id-put';
import { ApiWebInstytucjeNipRoboczeKrbIdPut$Params } from '../fn/operations/api-web-instytucje-nip-robocze-krb-id-put';
import { apiWebInstytucjeNipRoboczePost } from '../fn/operations/api-web-instytucje-nip-robocze-post';
import { ApiWebInstytucjeNipRoboczePost$Params } from '../fn/operations/api-web-instytucje-nip-robocze-post';
import { apiWebInstytucjeNipSzkoleniaGet } from '../fn/operations/api-web-instytucje-nip-szkolenia-get';
import { ApiWebInstytucjeNipSzkoleniaGet$Params } from '../fn/operations/api-web-instytucje-nip-szkolenia-get';
import { apiWebKomunikatyPubliczneGet } from '../fn/operations/api-web-komunikaty-publiczne-get';
import { ApiWebKomunikatyPubliczneGet$Params } from '../fn/operations/api-web-komunikaty-publiczne-get';
import { apiWebKorPost } from '../fn/operations/api-web-kor-post';
import { ApiWebKorPost$Params } from '../fn/operations/api-web-kor-post';
import { apiWebListysankcyjneDatyGet } from '../fn/operations/api-web-listysankcyjne-daty-get';
import { ApiWebListysankcyjneDatyGet$Params } from '../fn/operations/api-web-listysankcyjne-daty-get';
import { apiWebListysankcyjneGet } from '../fn/operations/api-web-listysankcyjne-get';
import { ApiWebListysankcyjneGet$Params } from '../fn/operations/api-web-listysankcyjne-get';
import { apiWebListysankcyjneZmianyGet } from '../fn/operations/api-web-listysankcyjne-zmiany-get';
import { ApiWebListysankcyjneZmianyGet$Params } from '../fn/operations/api-web-listysankcyjne-zmiany-get';
import { apiWebLoginAuthenticationPost } from '../fn/operations/api-web-login-authentication-post';
import { ApiWebLoginAuthenticationPost$Params } from '../fn/operations/api-web-login-authentication-post';
import { apiWebLoginChallengeGet } from '../fn/operations/api-web-login-challenge-get';
import { ApiWebLoginChallengeGet$Params } from '../fn/operations/api-web-login-challenge-get';
import { apiWebPapieroweInstytucjePost } from '../fn/operations/api-web-papierowe-instytucje-post';
import { ApiWebPapieroweInstytucjePost$Params } from '../fn/operations/api-web-papierowe-instytucje-post';
import { apiWebPapieroweTransakcjePost } from '../fn/operations/api-web-papierowe-transakcje-post';
import { ApiWebPapieroweTransakcjePost$Params } from '../fn/operations/api-web-papierowe-transakcje-post';
import { apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost } from '../fn/operations/api-web-papierowe-transakcje-wydruk-plz-id-checksum-post';
import { ApiWebPapieroweTransakcjeWydrukPlzIdChecksumPost$Params } from '../fn/operations/api-web-papierowe-transakcje-wydruk-plz-id-checksum-post';
import { apiWebPodpisaneInstytucjePost } from '../fn/operations/api-web-podpisane-instytucje-post';
import { ApiWebPodpisaneInstytucjePost$Params } from '../fn/operations/api-web-podpisane-instytucje-post';
import { apiWebPodpisaneTransakcjePost } from '../fn/operations/api-web-podpisane-transakcje-post';
import { ApiWebPodpisaneTransakcjePost$Params } from '../fn/operations/api-web-podpisane-transakcje-post';
import { apiWebSlownikiGet$Json } from '../fn/operations/api-web-slowniki-get-json';
import { ApiWebSlownikiGet$Json$Params } from '../fn/operations/api-web-slowniki-get-json';
import { apiWebSlownikiGet$Xml } from '../fn/operations/api-web-slowniki-get-xml';
import { ApiWebSlownikiGet$Xml$Params } from '../fn/operations/api-web-slowniki-get-xml';
import { apiWebSlownikiKodGet$Json } from '../fn/operations/api-web-slowniki-kod-get-json';
import { ApiWebSlownikiKodGet$Json$Params } from '../fn/operations/api-web-slowniki-kod-get-json';
import { apiWebSlownikiKodGet$Xml } from '../fn/operations/api-web-slowniki-kod-get-xml';
import { ApiWebSlownikiKodGet$Xml$Params } from '../fn/operations/api-web-slowniki-kod-get-xml';
import { apiWebSsologPost$Any } from '../fn/operations/api-web-ssolog-post-any';
import { ApiWebSsologPost$Any$Params } from '../fn/operations/api-web-ssolog-post-any';
import { apiWebSsologPost$Plain } from '../fn/operations/api-web-ssolog-post-plain';
import { ApiWebSsologPost$Plain$Params } from '../fn/operations/api-web-ssolog-post-plain';
import { apiWebSzkoleniaJwDostepneGet } from '../fn/operations/api-web-szkolenia-jw-dostepne-get';
import { ApiWebSzkoleniaJwDostepneGet$Params } from '../fn/operations/api-web-szkolenia-jw-dostepne-get';
import { apiWebTerytMiejscaGet } from '../fn/operations/api-web-teryt-miejsca-get';
import { ApiWebTerytMiejscaGet$Params } from '../fn/operations/api-web-teryt-miejsca-get';
import { apiWebTerytMiejscaSimcGet } from '../fn/operations/api-web-teryt-miejsca-simc-get';
import { ApiWebTerytMiejscaSimcGet$Params } from '../fn/operations/api-web-teryt-miejsca-simc-get';
import { apiWebTerytMiejscaSimcUliceUlicGet } from '../fn/operations/api-web-teryt-miejsca-simc-ulice-ulic-get';
import { ApiWebTerytMiejscaSimcUliceUlicGet$Params } from '../fn/operations/api-web-teryt-miejsca-simc-ulice-ulic-get';
import { apiWebTerytUliceGet } from '../fn/operations/api-web-teryt-ulice-get';
import { ApiWebTerytUliceGet$Params } from '../fn/operations/api-web-teryt-ulice-get';
import { apiWebTerytWojewodztwaGet } from '../fn/operations/api-web-teryt-wojewodztwa-get';
import { ApiWebTerytWojewodztwaGet$Params } from '../fn/operations/api-web-teryt-wojewodztwa-get';
import { apiWebTerytWojewodztwaWojPowiatyGet } from '../fn/operations/api-web-teryt-wojewodztwa-woj-powiaty-get';
import { ApiWebTerytWojewodztwaWojPowiatyGet$Params } from '../fn/operations/api-web-teryt-wojewodztwa-woj-powiaty-get';
import { apiWebTerytWojewodztwaWojPowiatyPowGminyGet } from '../fn/operations/api-web-teryt-wojewodztwa-woj-powiaty-pow-gminy-get';
import { ApiWebTerytWojewodztwaWojPowiatyPowGminyGet$Params } from '../fn/operations/api-web-teryt-wojewodztwa-woj-powiaty-pow-gminy-get';
import { apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet } from '../fn/operations/api-web-teryt-wojewodztwo-woj-powiaty-pow-gminy-gmi-rodz-get';
import { ApiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Params } from '../fn/operations/api-web-teryt-wojewodztwo-woj-powiaty-pow-gminy-gmi-rodz-get';
import { apiWebUpoGotowkaHashGet } from '../fn/operations/api-web-upo-gotowka-hash-get';
import { ApiWebUpoGotowkaHashGet$Params } from '../fn/operations/api-web-upo-gotowka-hash-get';
import { apiWebUpoInstytucjaHashGet } from '../fn/operations/api-web-upo-instytucja-hash-get';
import { ApiWebUpoInstytucjaHashGet$Params } from '../fn/operations/api-web-upo-instytucja-hash-get';
import { apiWebUpoInstytucjaKodGet } from '../fn/operations/api-web-upo-instytucja-kod-get';
import { ApiWebUpoInstytucjaKodGet$Params } from '../fn/operations/api-web-upo-instytucja-kod-get';
import { apiWebUpoNotariatHashGet } from '../fn/operations/api-web-upo-notariat-hash-get';
import { ApiWebUpoNotariatHashGet$Params } from '../fn/operations/api-web-upo-notariat-hash-get';
import { apiWebUpoTransakcjaHashGet } from '../fn/operations/api-web-upo-transakcja-hash-get';
import { ApiWebUpoTransakcjaHashGet$Params } from '../fn/operations/api-web-upo-transakcja-hash-get';
import { apiWebUpoTransakcjaHashPdfGet } from '../fn/operations/api-web-upo-transakcja-hash-pdf-get';
import { ApiWebUpoTransakcjaHashPdfGet$Params } from '../fn/operations/api-web-upo-transakcja-hash-pdf-get';
import { apiWebUpoTransakcjaKodGet } from '../fn/operations/api-web-upo-transakcja-kod-get';
import { ApiWebUpoTransakcjaKodGet$Params } from '../fn/operations/api-web-upo-transakcja-kod-get';
import { apiWebUpoTransakcjaKodPdfGet } from '../fn/operations/api-web-upo-transakcja-kod-pdf-get';
import { ApiWebUpoTransakcjaKodPdfGet$Params } from '../fn/operations/api-web-upo-transakcja-kod-pdf-get';
import { apiWebUpoTransferHashGet } from '../fn/operations/api-web-upo-transfer-hash-get';
import { ApiWebUpoTransferHashGet$Params } from '../fn/operations/api-web-upo-transfer-hash-get';
import { apiWebUpoWymianaHashGet } from '../fn/operations/api-web-upo-wymiana-hash-get';
import { ApiWebUpoWymianaHashGet$Params } from '../fn/operations/api-web-upo-wymiana-hash-get';
import { CertyfikatInstytucjiTo } from '../models/certyfikat-instytucji-to';
import { Dokument } from '../models/dokument';
import { KomunikatPublicznyTo } from '../models/komunikat-publiczny-to';
import { KomunikatTo } from '../models/komunikat-to';
import { KopiaRobocza } from '../models/kopia-robocza';
import { KopiaRoboczaIdent } from '../models/kopia-robocza-ident';
import { ListaInstytucji } from '../models/lista-instytucji';
import { SzkolenieTo } from '../models/szkolenie-to';
import { TerytSimcTo } from '../models/teryt-simc-to';
import { TerytTercTo } from '../models/teryt-terc-to';
import { TerytUlicTo } from '../models/teryt-ulic-to';
import { WpisTo } from '../models/wpis-to';
import { ZgloszenieIdentyfikator } from '../models/zgloszenie-identyfikator';

@Injectable({ providedIn: 'root' })
export class ApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiWebAnkietyNiepodpisanaPost()` */
  static readonly ApiWebAnkietyNiepodpisanaPostPath = '/api/web/ankiety/niepodpisana';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebAnkietyNiepodpisanaPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebAnkietyNiepodpisanaPost$Response(params?: ApiWebAnkietyNiepodpisanaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebAnkietyNiepodpisanaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebAnkietyNiepodpisanaPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebAnkietyNiepodpisanaPost(params?: ApiWebAnkietyNiepodpisanaPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebAnkietyNiepodpisanaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebAnkietyPodpisanaPost()` */
  static readonly ApiWebAnkietyPodpisanaPostPath = '/api/web/ankiety/podpisana';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebAnkietyPodpisanaPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebAnkietyPodpisanaPost$Response(params?: ApiWebAnkietyPodpisanaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebAnkietyPodpisanaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebAnkietyPodpisanaPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebAnkietyPodpisanaPost(params?: ApiWebAnkietyPodpisanaPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebAnkietyPodpisanaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebCzyIdentyfikatorKorektyWolnyGet()` */
  static readonly ApiWebCzyIdentyfikatorKorektyWolnyGetPath = '/api/web/czy/identyfikatorKorektyWolny';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebCzyIdentyfikatorKorektyWolnyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyIdentyfikatorKorektyWolnyGet$Response(params: ApiWebCzyIdentyfikatorKorektyWolnyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
    return apiWebCzyIdentyfikatorKorektyWolnyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebCzyIdentyfikatorKorektyWolnyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyIdentyfikatorKorektyWolnyGet(params: ApiWebCzyIdentyfikatorKorektyWolnyGet$Params, context?: HttpContext): Observable<AnswerTo> {
    return this.apiWebCzyIdentyfikatorKorektyWolnyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnswerTo>): AnswerTo => r.body)
    );
  }

  /** Path part for operation `apiWebCzyIdentyfikatorTrWolnyGet()` */
  static readonly ApiWebCzyIdentyfikatorTrWolnyGetPath = '/api/web/czy/identyfikatorTrWolny';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebCzyIdentyfikatorTrWolnyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyIdentyfikatorTrWolnyGet$Response(params: ApiWebCzyIdentyfikatorTrWolnyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
    return apiWebCzyIdentyfikatorTrWolnyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebCzyIdentyfikatorTrWolnyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyIdentyfikatorTrWolnyGet(params: ApiWebCzyIdentyfikatorTrWolnyGet$Params, context?: HttpContext): Observable<AnswerTo> {
    return this.apiWebCzyIdentyfikatorTrWolnyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnswerTo>): AnswerTo => r.body)
    );
  }

  /** Path part for operation `apiWebCzyIdentyfikatorTrZarejestrowanyGet()` */
  static readonly ApiWebCzyIdentyfikatorTrZarejestrowanyGetPath = '/api/web/czy/identyfikatorTrZarejestrowany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebCzyIdentyfikatorTrZarejestrowanyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyIdentyfikatorTrZarejestrowanyGet$Response(params: ApiWebCzyIdentyfikatorTrZarejestrowanyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
    return apiWebCzyIdentyfikatorTrZarejestrowanyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebCzyIdentyfikatorTrZarejestrowanyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyIdentyfikatorTrZarejestrowanyGet(params: ApiWebCzyIdentyfikatorTrZarejestrowanyGet$Params, context?: HttpContext): Observable<AnswerTo> {
    return this.apiWebCzyIdentyfikatorTrZarejestrowanyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnswerTo>): AnswerTo => r.body)
    );
  }

  /** Path part for operation `apiWebCzyInstytucjaNieZarejestrowanaGet()` */
  static readonly ApiWebCzyInstytucjaNieZarejestrowanaGetPath = '/api/web/czy/instytucjaNieZarejestrowana';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebCzyInstytucjaNieZarejestrowanaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyInstytucjaNieZarejestrowanaGet$Response(params: ApiWebCzyInstytucjaNieZarejestrowanaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
    return apiWebCzyInstytucjaNieZarejestrowanaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebCzyInstytucjaNieZarejestrowanaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyInstytucjaNieZarejestrowanaGet(params: ApiWebCzyInstytucjaNieZarejestrowanaGet$Params, context?: HttpContext): Observable<AnswerTo> {
    return this.apiWebCzyInstytucjaNieZarejestrowanaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnswerTo>): AnswerTo => r.body)
    );
  }

  /** Path part for operation `apiWebCzyInstytucjaZarejestrowanaGet()` */
  static readonly ApiWebCzyInstytucjaZarejestrowanaGetPath = '/api/web/czy/instytucjaZarejestrowana';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebCzyInstytucjaZarejestrowanaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyInstytucjaZarejestrowanaGet$Response(params: ApiWebCzyInstytucjaZarejestrowanaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
    return apiWebCzyInstytucjaZarejestrowanaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebCzyInstytucjaZarejestrowanaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyInstytucjaZarejestrowanaGet(params: ApiWebCzyInstytucjaZarejestrowanaGet$Params, context?: HttpContext): Observable<AnswerTo> {
    return this.apiWebCzyInstytucjaZarejestrowanaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnswerTo>): AnswerTo => r.body)
    );
  }

  /** Path part for operation `apiWebCzyUnikalnaNazwaInstytucjiGet()` */
  static readonly ApiWebCzyUnikalnaNazwaInstytucjiGetPath = '/api/web/czy/unikalnaNazwaInstytucji';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebCzyUnikalnaNazwaInstytucjiGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyUnikalnaNazwaInstytucjiGet$Response(params: ApiWebCzyUnikalnaNazwaInstytucjiGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
    return apiWebCzyUnikalnaNazwaInstytucjiGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebCzyUnikalnaNazwaInstytucjiGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebCzyUnikalnaNazwaInstytucjiGet(params: ApiWebCzyUnikalnaNazwaInstytucjiGet$Params, context?: HttpContext): Observable<AnswerTo> {
    return this.apiWebCzyUnikalnaNazwaInstytucjiGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnswerTo>): AnswerTo => r.body)
    );
  }

  /** Path part for operation `apiWebFaqGet()` */
  static readonly ApiWebFaqGetPath = '/api/web/faq';

  /**
   * Lista pytań FAQ.
   *
   * Pobierz listę pytań FAQ.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebFaqGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebFaqGet$Response(params?: ApiWebFaqGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KomunikatPublicznyTo>>> {
    return apiWebFaqGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista pytań FAQ.
   *
   * Pobierz listę pytań FAQ.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebFaqGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebFaqGet(params?: ApiWebFaqGet$Params, context?: HttpContext): Observable<Array<KomunikatPublicznyTo>> {
    return this.apiWebFaqGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KomunikatPublicznyTo>>): Array<KomunikatPublicznyTo> => r.body)
    );
  }

  /** Path part for operation `apiWebFaqKategorieGet()` */
  static readonly ApiWebFaqKategorieGetPath = '/api/web/faq/kategorie';

  /**
   * Lista kategorii FAQ.
   *
   * Pobierz listę kategorii FAQ.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebFaqKategorieGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebFaqKategorieGet$Response(params?: ApiWebFaqKategorieGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WpisTo>>> {
    return apiWebFaqKategorieGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista kategorii FAQ.
   *
   * Pobierz listę kategorii FAQ.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebFaqKategorieGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebFaqKategorieGet(params?: ApiWebFaqKategorieGet$Params, context?: HttpContext): Observable<Array<WpisTo>> {
    return this.apiWebFaqKategorieGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WpisTo>>): Array<WpisTo> => r.body)
    );
  }

  /** Path part for operation `apiWebHealthGet()` */
  static readonly ApiWebHealthGetPath = '/api/web/health';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebHealthGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthGet$Response(params?: ApiWebHealthGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebHealthGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebHealthGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthGet(params?: ApiWebHealthGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebHealthGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebHealthLiveGet()` */
  static readonly ApiWebHealthLiveGetPath = '/api/web/health/live';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebHealthLiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthLiveGet$Response(params?: ApiWebHealthLiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebHealthLiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebHealthLiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthLiveGet(params?: ApiWebHealthLiveGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebHealthLiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebHealthReadyGet()` */
  static readonly ApiWebHealthReadyGetPath = '/api/web/health/ready';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebHealthReadyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthReadyGet$Response(params?: ApiWebHealthReadyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebHealthReadyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebHealthReadyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthReadyGet(params?: ApiWebHealthReadyGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebHealthReadyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebHealthStartedGet()` */
  static readonly ApiWebHealthStartedGetPath = '/api/web/health/started';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebHealthStartedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthStartedGet$Response(params?: ApiWebHealthStartedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebHealthStartedGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebHealthStartedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebHealthStartedGet(params?: ApiWebHealthStartedGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebHealthStartedGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeGet()` */
  static readonly ApiWebInstytucjeGetPath = '/api/web/instytucje';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeGet$Xml$Response(params?: ApiWebInstytucjeGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ListaInstytucji>> {
    return apiWebInstytucjeGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeGet$Xml(params?: ApiWebInstytucjeGet$Xml$Params, context?: HttpContext): Observable<ListaInstytucji> {
    return this.apiWebInstytucjeGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ListaInstytucji>): ListaInstytucji => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeGet$Json$Response(params?: ApiWebInstytucjeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ListaInstytucji>> {
    return apiWebInstytucjeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeGet$Json(params?: ApiWebInstytucjeGet$Json$Params, context?: HttpContext): Observable<ListaInstytucji> {
    return this.apiWebInstytucjeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ListaInstytucji>): ListaInstytucji => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipGet()` */
  static readonly ApiWebInstytucjeNipGetPath = '/api/web/instytucje/{nip}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipGet$Xml$Response(params: ApiWebInstytucjeNipGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Dokument>> {
    return apiWebInstytucjeNipGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipGet$Xml(params: ApiWebInstytucjeNipGet$Xml$Params, context?: HttpContext): Observable<Dokument> {
    return this.apiWebInstytucjeNipGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Dokument>): Dokument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipGet$Json$Response(params: ApiWebInstytucjeNipGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Dokument>> {
    return apiWebInstytucjeNipGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipGet$Json(params: ApiWebInstytucjeNipGet$Json$Params, context?: HttpContext): Observable<Dokument> {
    return this.apiWebInstytucjeNipGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Dokument>): Dokument => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPut()` */
  static readonly ApiWebInstytucjeNipPutPath = '/api/web/instytucje/{nip}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPut()` instead.
   *
   * This method sends `text/xml` and handles request body of type `text/xml`.
   */
  apiWebInstytucjeNipPut$Response(params: ApiWebInstytucjeNipPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPut$Response()` instead.
   *
   * This method sends `text/xml` and handles request body of type `text/xml`.
   */
  apiWebInstytucjeNipPut(params: ApiWebInstytucjeNipPut$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipCertyfikatyGet()` */
  static readonly ApiWebInstytucjeNipCertyfikatyGetPath = '/api/web/instytucje/{nip}/certyfikaty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipCertyfikatyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipCertyfikatyGet$Response(params: ApiWebInstytucjeNipCertyfikatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CertyfikatInstytucjiTo>>> {
    return apiWebInstytucjeNipCertyfikatyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipCertyfikatyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipCertyfikatyGet(params: ApiWebInstytucjeNipCertyfikatyGet$Params, context?: HttpContext): Observable<Array<CertyfikatInstytucjiTo>> {
    return this.apiWebInstytucjeNipCertyfikatyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CertyfikatInstytucjiTo>>): Array<CertyfikatInstytucjiTo> => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipCertyfikatyPost()` */
  static readonly ApiWebInstytucjeNipCertyfikatyPostPath = '/api/web/instytucje/{nip}/certyfikaty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipCertyfikatyPost()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiWebInstytucjeNipCertyfikatyPost$Response(params: ApiWebInstytucjeNipCertyfikatyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipCertyfikatyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipCertyfikatyPost$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiWebInstytucjeNipCertyfikatyPost(params: ApiWebInstytucjeNipCertyfikatyPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipCertyfikatyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipHistoriaGet()` */
  static readonly ApiWebInstytucjeNipHistoriaGetPath = '/api/web/instytucje/{nip}/historia';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipHistoriaGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaGet$Json$Response(params: ApiWebInstytucjeNipHistoriaGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZgloszenieIdentyfikator>>> {
    return apiWebInstytucjeNipHistoriaGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipHistoriaGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaGet$Json(params: ApiWebInstytucjeNipHistoriaGet$Json$Params, context?: HttpContext): Observable<Array<ZgloszenieIdentyfikator>> {
    return this.apiWebInstytucjeNipHistoriaGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ZgloszenieIdentyfikator>>): Array<ZgloszenieIdentyfikator> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipHistoriaGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaGet$Xml$Response(params: ApiWebInstytucjeNipHistoriaGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZgloszenieIdentyfikator>>> {
    return apiWebInstytucjeNipHistoriaGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipHistoriaGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaGet$Xml(params: ApiWebInstytucjeNipHistoriaGet$Xml$Params, context?: HttpContext): Observable<Array<ZgloszenieIdentyfikator>> {
    return this.apiWebInstytucjeNipHistoriaGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ZgloszenieIdentyfikator>>): Array<ZgloszenieIdentyfikator> => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipHistoriaZioIdGet()` */
  static readonly ApiWebInstytucjeNipHistoriaZioIdGetPath = '/api/web/instytucje/{nip}/historia/{zioId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipHistoriaZioIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaZioIdGet$Json$Response(params: ApiWebInstytucjeNipHistoriaZioIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Dokument>> {
    return apiWebInstytucjeNipHistoriaZioIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipHistoriaZioIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaZioIdGet$Json(params: ApiWebInstytucjeNipHistoriaZioIdGet$Json$Params, context?: HttpContext): Observable<Dokument> {
    return this.apiWebInstytucjeNipHistoriaZioIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Dokument>): Dokument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipHistoriaZioIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaZioIdGet$Xml$Response(params: ApiWebInstytucjeNipHistoriaZioIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Dokument>> {
    return apiWebInstytucjeNipHistoriaZioIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipHistoriaZioIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipHistoriaZioIdGet$Xml(params: ApiWebInstytucjeNipHistoriaZioIdGet$Xml$Params, context?: HttpContext): Observable<Dokument> {
    return this.apiWebInstytucjeNipHistoriaZioIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Dokument>): Dokument => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipKomunikatyGet()` */
  static readonly ApiWebInstytucjeNipKomunikatyGetPath = '/api/web/instytucje/{nip}/komunikaty';

  /**
   * Lista komunikatów widocznych po zalogowaniu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipKomunikatyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipKomunikatyGet$Response(params: ApiWebInstytucjeNipKomunikatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KomunikatTo>>> {
    return apiWebInstytucjeNipKomunikatyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista komunikatów widocznych po zalogowaniu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipKomunikatyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipKomunikatyGet(params: ApiWebInstytucjeNipKomunikatyGet$Params, context?: HttpContext): Observable<Array<KomunikatTo>> {
    return this.apiWebInstytucjeNipKomunikatyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KomunikatTo>>): Array<KomunikatTo> => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipKomunikatyIdZalacznikGet()` */
  static readonly ApiWebInstytucjeNipKomunikatyIdZalacznikGetPath = '/api/web/instytucje/{nip}/komunikaty/{id}/zalacznik';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipKomunikatyIdZalacznikGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipKomunikatyIdZalacznikGet$Response(params: ApiWebInstytucjeNipKomunikatyIdZalacznikGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipKomunikatyIdZalacznikGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipKomunikatyIdZalacznikGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipKomunikatyIdZalacznikGet(params: ApiWebInstytucjeNipKomunikatyIdZalacznikGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipKomunikatyIdZalacznikGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiGet()` */
  static readonly ApiWebInstytucjeNipPlikiGetPath = '/api/web/instytucje/{nip}/pliki';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiGet$Xml$Response(params: ApiWebInstytucjeNipPlikiGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebInstytucjeNipPlikiGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiGet$Xml(params: ApiWebInstytucjeNipPlikiGet$Xml$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebInstytucjeNipPlikiGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiGet$Json$Response(params: ApiWebInstytucjeNipPlikiGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebInstytucjeNipPlikiGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiGet$Json(params: ApiWebInstytucjeNipPlikiGet$Json$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebInstytucjeNipPlikiGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiPost()` */
  static readonly ApiWebInstytucjeNipPlikiPostPath = '/api/web/instytucje/{nip}/pliki';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPost$Response(params: ApiWebInstytucjeNipPlikiPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipPlikiPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPost(params: ApiWebInstytucjeNipPlikiPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipPlikiPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiNiezaszyfrowanyPost()` */
  static readonly ApiWebInstytucjeNipPlikiNiezaszyfrowanyPostPath = '/api/web/instytucje/{nip}/pliki/niezaszyfrowany';

  /**
   * Wyślij niezaszyfrowany plik.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Response(params: ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Wyślij niezaszyfrowany plik.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf(params: ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Params, context?: HttpContext): Observable<Blob> {
    return this.apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Wyślij niezaszyfrowany plik.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip$Response(params: ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip(this.http, this.rootUrl, params, context);
  }

  /**
   * Wyślij niezaszyfrowany plik.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip(params: ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip$Params, context?: HttpContext): Observable<Blob> {
    return this.apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Zip$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiPlzIdGet()` */
  static readonly ApiWebInstytucjeNipPlikiPlzIdGetPath = '/api/web/instytucje/{nip}/pliki/{plzId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPlzIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdGet$Xml$Response(params: ApiWebInstytucjeNipPlikiPlzIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebInstytucjeNipPlikiPlzIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPlzIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdGet$Xml(params: ApiWebInstytucjeNipPlikiPlzIdGet$Xml$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebInstytucjeNipPlikiPlzIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPlzIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdGet$Json$Response(params: ApiWebInstytucjeNipPlikiPlzIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebInstytucjeNipPlikiPlzIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPlzIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdGet$Json(params: ApiWebInstytucjeNipPlikiPlzIdGet$Json$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebInstytucjeNipPlikiPlzIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet()` */
  static readonly ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGetPath = '/api/web/instytucje/{nip}/pliki/{plzId}/identyfikatory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml$Response(params: ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml(params: ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Response(params: ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json(params: ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiPlzIdUpoGet()` */
  static readonly ApiWebInstytucjeNipPlikiPlzIdUpoGetPath = '/api/web/instytucje/{nip}/pliki/{plzId}/upo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPlzIdUpoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdUpoGet$Response(params: ApiWebInstytucjeNipPlikiPlzIdUpoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipPlikiPlzIdUpoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPlzIdUpoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdUpoGet(params: ApiWebInstytucjeNipPlikiPlzIdUpoGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipPlikiPlzIdUpoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipPlikiPlzIdUpoPdfGet()` */
  static readonly ApiWebInstytucjeNipPlikiPlzIdUpoPdfGetPath = '/api/web/instytucje/{nip}/pliki/{plzId}/upo/pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipPlikiPlzIdUpoPdfGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdUpoPdfGet$Response(params: ApiWebInstytucjeNipPlikiPlzIdUpoPdfGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipPlikiPlzIdUpoPdfGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipPlikiPlzIdUpoPdfGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipPlikiPlzIdUpoPdfGet(params: ApiWebInstytucjeNipPlikiPlzIdUpoPdfGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipPlikiPlzIdUpoPdfGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipRoboczeGet()` */
  static readonly ApiWebInstytucjeNipRoboczeGetPath = '/api/web/instytucje/{nip}/robocze';

  /**
   * Lista kopii roboczych, bez właściwości dane.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipRoboczeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeGet$Response(params: ApiWebInstytucjeNipRoboczeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KopiaRobocza>>> {
    return apiWebInstytucjeNipRoboczeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista kopii roboczych, bez właściwości dane.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipRoboczeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeGet(params: ApiWebInstytucjeNipRoboczeGet$Params, context?: HttpContext): Observable<Array<KopiaRobocza>> {
    return this.apiWebInstytucjeNipRoboczeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KopiaRobocza>>): Array<KopiaRobocza> => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipRoboczePost()` */
  static readonly ApiWebInstytucjeNipRoboczePostPath = '/api/web/instytucje/{nip}/robocze';

  /**
   * Tworzy nową kopię roboczą.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipRoboczePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczePost$Response(params: ApiWebInstytucjeNipRoboczePost$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Identyfikator nadawany przez backend, nie wypełniać przy tworzeniu.
 */
'id'?: number;

/**
 * Data utworzenia nadawana przez backend, nie wypełniać.
 */
'dataUtworzenia'?: string;

/**
 * Identyfikator SSO użytkownika, który utworzył kopię, nadawany przez backend.
 */
'ssoIdUtworzenia'?: string;

/**
 * Data modyfikacji nadawna przez backend.
 */
'dataModyfikacji'?: string;

/**
 * Identyfikator SSO użytkownika, który zmodyfikował kopię, nadawany przez backend.
 */
'ssoIdModyfikacji'?: string;

/**
 * Data przydatności do spożycia, nadawana przez backend.
 */
'dataWygasniecia'?: string;

/**
 * Identyfikator GoAML użytkownika oznaczonego jako wysyłający raport.
 */
'uzytkownikGoAML': string;

/**
 * Lista identyfikatorów transakcji w tej kopii roboczej.
 */
'identyfikatory': Array<KopiaRoboczaIdent>;

/**
 * Dane kopii roboczej, jako pojedynczy string, backend przekazuje tylko przy pobieraniu pojedynczej kopii.
 */
'dane': string;
}>> {
    return apiWebInstytucjeNipRoboczePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Tworzy nową kopię roboczą.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipRoboczePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczePost(params: ApiWebInstytucjeNipRoboczePost$Params, context?: HttpContext): Observable<{

/**
 * Identyfikator nadawany przez backend, nie wypełniać przy tworzeniu.
 */
'id'?: number;

/**
 * Data utworzenia nadawana przez backend, nie wypełniać.
 */
'dataUtworzenia'?: string;

/**
 * Identyfikator SSO użytkownika, który utworzył kopię, nadawany przez backend.
 */
'ssoIdUtworzenia'?: string;

/**
 * Data modyfikacji nadawna przez backend.
 */
'dataModyfikacji'?: string;

/**
 * Identyfikator SSO użytkownika, który zmodyfikował kopię, nadawany przez backend.
 */
'ssoIdModyfikacji'?: string;

/**
 * Data przydatności do spożycia, nadawana przez backend.
 */
'dataWygasniecia'?: string;

/**
 * Identyfikator GoAML użytkownika oznaczonego jako wysyłający raport.
 */
'uzytkownikGoAML': string;

/**
 * Lista identyfikatorów transakcji w tej kopii roboczej.
 */
'identyfikatory': Array<KopiaRoboczaIdent>;

/**
 * Dane kopii roboczej, jako pojedynczy string, backend przekazuje tylko przy pobieraniu pojedynczej kopii.
 */
'dane': string;
}> {
    return this.apiWebInstytucjeNipRoboczePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * Identyfikator nadawany przez backend, nie wypełniać przy tworzeniu.
 */
'id'?: number;

/**
 * Data utworzenia nadawana przez backend, nie wypełniać.
 */
'dataUtworzenia'?: string;

/**
 * Identyfikator SSO użytkownika, który utworzył kopię, nadawany przez backend.
 */
'ssoIdUtworzenia'?: string;

/**
 * Data modyfikacji nadawna przez backend.
 */
'dataModyfikacji'?: string;

/**
 * Identyfikator SSO użytkownika, który zmodyfikował kopię, nadawany przez backend.
 */
'ssoIdModyfikacji'?: string;

/**
 * Data przydatności do spożycia, nadawana przez backend.
 */
'dataWygasniecia'?: string;

/**
 * Identyfikator GoAML użytkownika oznaczonego jako wysyłający raport.
 */
'uzytkownikGoAML': string;

/**
 * Lista identyfikatorów transakcji w tej kopii roboczej.
 */
'identyfikatory': Array<KopiaRoboczaIdent>;

/**
 * Dane kopii roboczej, jako pojedynczy string, backend przekazuje tylko przy pobieraniu pojedynczej kopii.
 */
'dane': string;
}>): {

/**
 * Identyfikator nadawany przez backend, nie wypełniać przy tworzeniu.
 */
'id'?: number;

/**
 * Data utworzenia nadawana przez backend, nie wypełniać.
 */
'dataUtworzenia'?: string;

/**
 * Identyfikator SSO użytkownika, który utworzył kopię, nadawany przez backend.
 */
'ssoIdUtworzenia'?: string;

/**
 * Data modyfikacji nadawna przez backend.
 */
'dataModyfikacji'?: string;

/**
 * Identyfikator SSO użytkownika, który zmodyfikował kopię, nadawany przez backend.
 */
'ssoIdModyfikacji'?: string;

/**
 * Data przydatności do spożycia, nadawana przez backend.
 */
'dataWygasniecia'?: string;

/**
 * Identyfikator GoAML użytkownika oznaczonego jako wysyłający raport.
 */
'uzytkownikGoAML': string;

/**
 * Lista identyfikatorów transakcji w tej kopii roboczej.
 */
'identyfikatory': Array<KopiaRoboczaIdent>;

/**
 * Dane kopii roboczej, jako pojedynczy string, backend przekazuje tylko przy pobieraniu pojedynczej kopii.
 */
'dane': string;
} => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipRoboczeKrbIdGet()` */
  static readonly ApiWebInstytucjeNipRoboczeKrbIdGetPath = '/api/web/instytucje/{nip}/robocze/{krbId}';

  /**
   * Pobierz jedną kopię roboczą, z właściwością dane.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipRoboczeKrbIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeKrbIdGet$Response(params: ApiWebInstytucjeNipRoboczeKrbIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<KopiaRobocza>> {
    return apiWebInstytucjeNipRoboczeKrbIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Pobierz jedną kopię roboczą, z właściwością dane.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipRoboczeKrbIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeKrbIdGet(params: ApiWebInstytucjeNipRoboczeKrbIdGet$Params, context?: HttpContext): Observable<KopiaRobocza> {
    return this.apiWebInstytucjeNipRoboczeKrbIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<KopiaRobocza>): KopiaRobocza => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipRoboczeKrbIdPut()` */
  static readonly ApiWebInstytucjeNipRoboczeKrbIdPutPath = '/api/web/instytucje/{nip}/robocze/{krbId}';

  /**
   * Modyfikuje kopię roboczą.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipRoboczeKrbIdPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeKrbIdPut$Response(params: ApiWebInstytucjeNipRoboczeKrbIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<KopiaRobocza>> {
    return apiWebInstytucjeNipRoboczeKrbIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Modyfikuje kopię roboczą.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipRoboczeKrbIdPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeKrbIdPut(params: ApiWebInstytucjeNipRoboczeKrbIdPut$Params, context?: HttpContext): Observable<KopiaRobocza> {
    return this.apiWebInstytucjeNipRoboczeKrbIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<KopiaRobocza>): KopiaRobocza => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipRoboczeKrbIdDelete()` */
  static readonly ApiWebInstytucjeNipRoboczeKrbIdDeletePath = '/api/web/instytucje/{nip}/robocze/{krbId}';

  /**
   * Usuwa kopię roboczą.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipRoboczeKrbIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeKrbIdDelete$Response(params: ApiWebInstytucjeNipRoboczeKrbIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebInstytucjeNipRoboczeKrbIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Usuwa kopię roboczą.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipRoboczeKrbIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipRoboczeKrbIdDelete(params: ApiWebInstytucjeNipRoboczeKrbIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiWebInstytucjeNipRoboczeKrbIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebInstytucjeNipSzkoleniaGet()` */
  static readonly ApiWebInstytucjeNipSzkoleniaGetPath = '/api/web/instytucje/{nip}/szkolenia';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebInstytucjeNipSzkoleniaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipSzkoleniaGet$Response(params: ApiWebInstytucjeNipSzkoleniaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SzkolenieTo>>> {
    return apiWebInstytucjeNipSzkoleniaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebInstytucjeNipSzkoleniaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebInstytucjeNipSzkoleniaGet(params: ApiWebInstytucjeNipSzkoleniaGet$Params, context?: HttpContext): Observable<Array<SzkolenieTo>> {
    return this.apiWebInstytucjeNipSzkoleniaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SzkolenieTo>>): Array<SzkolenieTo> => r.body)
    );
  }

  /** Path part for operation `apiWebKomunikatyPubliczneGet()` */
  static readonly ApiWebKomunikatyPubliczneGetPath = '/api/web/komunikatyPubliczne';

  /**
   * Komunikaty publiczne.
   *
   * Pobiera listę komunikatów dostępnych bez logowania.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebKomunikatyPubliczneGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebKomunikatyPubliczneGet$Response(params?: ApiWebKomunikatyPubliczneGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KomunikatPublicznyTo>>> {
    return apiWebKomunikatyPubliczneGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Komunikaty publiczne.
   *
   * Pobiera listę komunikatów dostępnych bez logowania.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebKomunikatyPubliczneGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebKomunikatyPubliczneGet(params?: ApiWebKomunikatyPubliczneGet$Params, context?: HttpContext): Observable<Array<KomunikatPublicznyTo>> {
    return this.apiWebKomunikatyPubliczneGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KomunikatPublicznyTo>>): Array<KomunikatPublicznyTo> => r.body)
    );
  }

  /** Path part for operation `apiWebKorPost()` */
  static readonly ApiWebKorPostPath = '/api/web/kor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebKorPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebKorPost$Response(params: ApiWebKorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebKorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebKorPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebKorPost(params: ApiWebKorPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebKorPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebListysankcyjneGet()` */
  static readonly ApiWebListysankcyjneGetPath = '/api/web/listysankcyjne';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebListysankcyjneGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebListysankcyjneGet$Response(params?: ApiWebListysankcyjneGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebListysankcyjneGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebListysankcyjneGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebListysankcyjneGet(params?: ApiWebListysankcyjneGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebListysankcyjneGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebListysankcyjneDatyGet()` */
  static readonly ApiWebListysankcyjneDatyGetPath = '/api/web/listysankcyjne/daty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebListysankcyjneDatyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebListysankcyjneDatyGet$Response(params?: ApiWebListysankcyjneDatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    return apiWebListysankcyjneDatyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebListysankcyjneDatyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebListysankcyjneDatyGet(params?: ApiWebListysankcyjneDatyGet$Params, context?: HttpContext): Observable<Array<number>> {
    return this.apiWebListysankcyjneDatyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `apiWebListysankcyjneZmianyGet()` */
  static readonly ApiWebListysankcyjneZmianyGetPath = '/api/web/listysankcyjne/zmiany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebListysankcyjneZmianyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebListysankcyjneZmianyGet$Response(params?: ApiWebListysankcyjneZmianyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebListysankcyjneZmianyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebListysankcyjneZmianyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebListysankcyjneZmianyGet(params?: ApiWebListysankcyjneZmianyGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebListysankcyjneZmianyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebLoginAuthenticationPost()` */
  static readonly ApiWebLoginAuthenticationPostPath = '/api/web/login/authentication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebLoginAuthenticationPost()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   *
   * @deprecated
   */
  apiWebLoginAuthenticationPost$Response(params?: ApiWebLoginAuthenticationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebLoginAuthenticationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebLoginAuthenticationPost$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   *
   * @deprecated
   */
  apiWebLoginAuthenticationPost(params?: ApiWebLoginAuthenticationPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebLoginAuthenticationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebLoginChallengeGet()` */
  static readonly ApiWebLoginChallengeGetPath = '/api/web/login/challenge';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebLoginChallengeGet()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  apiWebLoginChallengeGet$Response(params?: ApiWebLoginChallengeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebLoginChallengeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebLoginChallengeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  apiWebLoginChallengeGet(params?: ApiWebLoginChallengeGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebLoginChallengeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebPapieroweInstytucjePost()` */
  static readonly ApiWebPapieroweInstytucjePostPath = '/api/web/papierowe/instytucje';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebPapieroweInstytucjePost()` instead.
   *
   * This method sends `text/xml` and handles request body of type `text/xml`.
   */
  apiWebPapieroweInstytucjePost$Response(params?: ApiWebPapieroweInstytucjePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebPapieroweInstytucjePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebPapieroweInstytucjePost$Response()` instead.
   *
   * This method sends `text/xml` and handles request body of type `text/xml`.
   */
  apiWebPapieroweInstytucjePost(params?: ApiWebPapieroweInstytucjePost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebPapieroweInstytucjePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebPapieroweTransakcjePost()` */
  static readonly ApiWebPapieroweTransakcjePostPath = '/api/web/papierowe/transakcje';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebPapieroweTransakcjePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebPapieroweTransakcjePost$Response(params?: ApiWebPapieroweTransakcjePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebPapieroweTransakcjePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebPapieroweTransakcjePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebPapieroweTransakcjePost(params?: ApiWebPapieroweTransakcjePost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebPapieroweTransakcjePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost()` */
  static readonly ApiWebPapieroweTransakcjeWydrukPlzIdChecksumPostPath = '/api/web/papierowe/transakcje/wydruk/{plzId}/{checksum}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost$Response(params: ApiWebPapieroweTransakcjeWydrukPlzIdChecksumPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost(params: ApiWebPapieroweTransakcjeWydrukPlzIdChecksumPost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebPapieroweTransakcjeWydrukPlzIdChecksumPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebPodpisaneInstytucjePost()` */
  static readonly ApiWebPodpisaneInstytucjePostPath = '/api/web/podpisane/instytucje';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebPodpisaneInstytucjePost()` instead.
   *
   * This method sends `text/xml` and handles request body of type `text/xml`.
   */
  apiWebPodpisaneInstytucjePost$Response(params?: ApiWebPodpisaneInstytucjePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebPodpisaneInstytucjePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebPodpisaneInstytucjePost$Response()` instead.
   *
   * This method sends `text/xml` and handles request body of type `text/xml`.
   */
  apiWebPodpisaneInstytucjePost(params?: ApiWebPodpisaneInstytucjePost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebPodpisaneInstytucjePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebPodpisaneTransakcjePost()` */
  static readonly ApiWebPodpisaneTransakcjePostPath = '/api/web/podpisane/transakcje';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebPodpisaneTransakcjePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebPodpisaneTransakcjePost$Response(params?: ApiWebPodpisaneTransakcjePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebPodpisaneTransakcjePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebPodpisaneTransakcjePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebPodpisaneTransakcjePost(params?: ApiWebPodpisaneTransakcjePost$Params, context?: HttpContext): Observable<void> {
    return this.apiWebPodpisaneTransakcjePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebSlownikiGet()` */
  static readonly ApiWebSlownikiGetPath = '/api/web/slowniki';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSlownikiGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiGet$Xml$Response(params?: ApiWebSlownikiGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebSlownikiGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSlownikiGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiGet$Xml(params?: ApiWebSlownikiGet$Xml$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebSlownikiGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSlownikiGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiGet$Json$Response(params?: ApiWebSlownikiGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebSlownikiGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSlownikiGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiGet$Json(params?: ApiWebSlownikiGet$Json$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebSlownikiGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `apiWebSlownikiKodGet()` */
  static readonly ApiWebSlownikiKodGetPath = '/api/web/slowniki/{kod}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSlownikiKodGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiKodGet$Xml$Response(params: ApiWebSlownikiKodGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebSlownikiKodGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSlownikiKodGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiKodGet$Xml(params: ApiWebSlownikiKodGet$Xml$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebSlownikiKodGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSlownikiKodGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiKodGet$Json$Response(params: ApiWebSlownikiKodGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return apiWebSlownikiKodGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSlownikiKodGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSlownikiKodGet$Json(params: ApiWebSlownikiKodGet$Json$Params, context?: HttpContext): Observable<{
}> {
    return this.apiWebSlownikiKodGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `apiWebSsologPost()` */
  static readonly ApiWebSsologPostPath = '/api/web/ssolog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSsologPost$Plain()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiWebSsologPost$Plain$Response(params?: ApiWebSsologPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebSsologPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSsologPost$Plain$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiWebSsologPost$Plain(params?: ApiWebSsologPost$Plain$Params, context?: HttpContext): Observable<void> {
    return this.apiWebSsologPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSsologPost$Any()` instead.
   *
   * This method sends `*` and handles request body of type `*`.
   */
  apiWebSsologPost$Any$Response(params?: ApiWebSsologPost$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebSsologPost$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSsologPost$Any$Response()` instead.
   *
   * This method sends `*` and handles request body of type `*`.
   */
  apiWebSsologPost$Any(params?: ApiWebSsologPost$Any$Params, context?: HttpContext): Observable<void> {
    return this.apiWebSsologPost$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebSzkoleniaJwDostepneGet()` */
  static readonly ApiWebSzkoleniaJwDostepneGetPath = '/api/web/szkolenia_jw/dostepne';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebSzkoleniaJwDostepneGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSzkoleniaJwDostepneGet$Response(params?: ApiWebSzkoleniaJwDostepneGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SzkolenieTo>>> {
    return apiWebSzkoleniaJwDostepneGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebSzkoleniaJwDostepneGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebSzkoleniaJwDostepneGet(params?: ApiWebSzkoleniaJwDostepneGet$Params, context?: HttpContext): Observable<Array<SzkolenieTo>> {
    return this.apiWebSzkoleniaJwDostepneGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SzkolenieTo>>): Array<SzkolenieTo> => r.body)
    );
  }

  /** Path part for operation `apiWebTerytMiejscaGet()` */
  static readonly ApiWebTerytMiejscaGetPath = '/api/web/teryt/miejsca';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytMiejscaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytMiejscaGet$Response(params?: ApiWebTerytMiejscaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytSimcTo>>> {
    return apiWebTerytMiejscaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytMiejscaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytMiejscaGet(params?: ApiWebTerytMiejscaGet$Params, context?: HttpContext): Observable<Array<TerytSimcTo>> {
    return this.apiWebTerytMiejscaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TerytSimcTo>>): Array<TerytSimcTo> => r.body)
    );
  }

  /** Path part for operation `apiWebTerytMiejscaSimcGet()` */
  static readonly ApiWebTerytMiejscaSimcGetPath = '/api/web/teryt/miejsca/{simc}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytMiejscaSimcGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytMiejscaSimcGet$Response(params: ApiWebTerytMiejscaSimcGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TerytSimcTo>> {
    return apiWebTerytMiejscaSimcGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytMiejscaSimcGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytMiejscaSimcGet(params: ApiWebTerytMiejscaSimcGet$Params, context?: HttpContext): Observable<TerytSimcTo> {
    return this.apiWebTerytMiejscaSimcGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TerytSimcTo>): TerytSimcTo => r.body)
    );
  }

  /** Path part for operation `apiWebTerytMiejscaSimcUliceUlicGet()` */
  static readonly ApiWebTerytMiejscaSimcUliceUlicGetPath = '/api/web/teryt/miejsca/{simc}/ulice/{ulic}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytMiejscaSimcUliceUlicGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytMiejscaSimcUliceUlicGet$Response(params: ApiWebTerytMiejscaSimcUliceUlicGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TerytUlicTo>> {
    return apiWebTerytMiejscaSimcUliceUlicGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytMiejscaSimcUliceUlicGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytMiejscaSimcUliceUlicGet(params: ApiWebTerytMiejscaSimcUliceUlicGet$Params, context?: HttpContext): Observable<TerytUlicTo> {
    return this.apiWebTerytMiejscaSimcUliceUlicGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TerytUlicTo>): TerytUlicTo => r.body)
    );
  }

  /** Path part for operation `apiWebTerytUliceGet()` */
  static readonly ApiWebTerytUliceGetPath = '/api/web/teryt/ulice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytUliceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytUliceGet$Response(params?: ApiWebTerytUliceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytUlicTo>>> {
    return apiWebTerytUliceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytUliceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytUliceGet(params?: ApiWebTerytUliceGet$Params, context?: HttpContext): Observable<Array<TerytUlicTo>> {
    return this.apiWebTerytUliceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TerytUlicTo>>): Array<TerytUlicTo> => r.body)
    );
  }

  /** Path part for operation `apiWebTerytWojewodztwaGet()` */
  static readonly ApiWebTerytWojewodztwaGetPath = '/api/web/teryt/wojewodztwa';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytWojewodztwaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwaGet$Response(params?: ApiWebTerytWojewodztwaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytTercTo>>> {
    return apiWebTerytWojewodztwaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytWojewodztwaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwaGet(params?: ApiWebTerytWojewodztwaGet$Params, context?: HttpContext): Observable<Array<TerytTercTo>> {
    return this.apiWebTerytWojewodztwaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TerytTercTo>>): Array<TerytTercTo> => r.body)
    );
  }

  /** Path part for operation `apiWebTerytWojewodztwaWojPowiatyGet()` */
  static readonly ApiWebTerytWojewodztwaWojPowiatyGetPath = '/api/web/teryt/wojewodztwa/{woj}/powiaty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytWojewodztwaWojPowiatyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwaWojPowiatyGet$Response(params: ApiWebTerytWojewodztwaWojPowiatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytTercTo>>> {
    return apiWebTerytWojewodztwaWojPowiatyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytWojewodztwaWojPowiatyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwaWojPowiatyGet(params: ApiWebTerytWojewodztwaWojPowiatyGet$Params, context?: HttpContext): Observable<Array<TerytTercTo>> {
    return this.apiWebTerytWojewodztwaWojPowiatyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TerytTercTo>>): Array<TerytTercTo> => r.body)
    );
  }

  /** Path part for operation `apiWebTerytWojewodztwaWojPowiatyPowGminyGet()` */
  static readonly ApiWebTerytWojewodztwaWojPowiatyPowGminyGetPath = '/api/web/teryt/wojewodztwa/{woj}/powiaty/{pow}/gminy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytWojewodztwaWojPowiatyPowGminyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwaWojPowiatyPowGminyGet$Response(params: ApiWebTerytWojewodztwaWojPowiatyPowGminyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytTercTo>>> {
    return apiWebTerytWojewodztwaWojPowiatyPowGminyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytWojewodztwaWojPowiatyPowGminyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwaWojPowiatyPowGminyGet(params: ApiWebTerytWojewodztwaWojPowiatyPowGminyGet$Params, context?: HttpContext): Observable<Array<TerytTercTo>> {
    return this.apiWebTerytWojewodztwaWojPowiatyPowGminyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TerytTercTo>>): Array<TerytTercTo> => r.body)
    );
  }

  /** Path part for operation `apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet()` */
  static readonly ApiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGetPath = '/api/web/teryt/wojewodztwo/{woj}/powiaty/{pow}/gminy/{gmi}/{rodz}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Response(params: ApiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TerytTercTo>> {
    return apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet(params: ApiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Params, context?: HttpContext): Observable<TerytTercTo> {
    return this.apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TerytTercTo>): TerytTercTo => r.body)
    );
  }

  /** Path part for operation `apiWebUpoGotowkaHashGet()` */
  static readonly ApiWebUpoGotowkaHashGetPath = '/api/web/upo/gotowka/{hash}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoGotowkaHashGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoGotowkaHashGet$Response(params: ApiWebUpoGotowkaHashGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoGotowkaHashGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoGotowkaHashGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoGotowkaHashGet(params: ApiWebUpoGotowkaHashGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoGotowkaHashGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoInstytucjaHashGet()` */
  static readonly ApiWebUpoInstytucjaHashGetPath = '/api/web/upo/instytucja/{hash}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoInstytucjaHashGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoInstytucjaHashGet$Response(params: ApiWebUpoInstytucjaHashGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoInstytucjaHashGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoInstytucjaHashGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoInstytucjaHashGet(params: ApiWebUpoInstytucjaHashGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoInstytucjaHashGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoInstytucjaKodGet()` */
  static readonly ApiWebUpoInstytucjaKodGetPath = '/api/web/upo/instytucja/{kod}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoInstytucjaKodGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoInstytucjaKodGet$Response(params: ApiWebUpoInstytucjaKodGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoInstytucjaKodGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoInstytucjaKodGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoInstytucjaKodGet(params: ApiWebUpoInstytucjaKodGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoInstytucjaKodGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoNotariatHashGet()` */
  static readonly ApiWebUpoNotariatHashGetPath = '/api/web/upo/notariat/{hash}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoNotariatHashGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoNotariatHashGet$Response(params: ApiWebUpoNotariatHashGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoNotariatHashGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoNotariatHashGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoNotariatHashGet(params: ApiWebUpoNotariatHashGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoNotariatHashGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoTransakcjaHashGet()` */
  static readonly ApiWebUpoTransakcjaHashGetPath = '/api/web/upo/transakcja/{hash}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoTransakcjaHashGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaHashGet$Response(params: ApiWebUpoTransakcjaHashGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoTransakcjaHashGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoTransakcjaHashGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaHashGet(params: ApiWebUpoTransakcjaHashGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoTransakcjaHashGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoTransakcjaHashPdfGet()` */
  static readonly ApiWebUpoTransakcjaHashPdfGetPath = '/api/web/upo/transakcja/{hash}/pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoTransakcjaHashPdfGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaHashPdfGet$Response(params: ApiWebUpoTransakcjaHashPdfGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoTransakcjaHashPdfGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoTransakcjaHashPdfGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaHashPdfGet(params: ApiWebUpoTransakcjaHashPdfGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoTransakcjaHashPdfGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoTransakcjaKodGet()` */
  static readonly ApiWebUpoTransakcjaKodGetPath = '/api/web/upo/transakcja/{kod}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoTransakcjaKodGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaKodGet$Response(params: ApiWebUpoTransakcjaKodGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoTransakcjaKodGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoTransakcjaKodGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaKodGet(params: ApiWebUpoTransakcjaKodGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoTransakcjaKodGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoTransakcjaKodPdfGet()` */
  static readonly ApiWebUpoTransakcjaKodPdfGetPath = '/api/web/upo/transakcja/{kod}/pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoTransakcjaKodPdfGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaKodPdfGet$Response(params: ApiWebUpoTransakcjaKodPdfGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoTransakcjaKodPdfGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoTransakcjaKodPdfGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransakcjaKodPdfGet(params: ApiWebUpoTransakcjaKodPdfGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoTransakcjaKodPdfGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoTransferHashGet()` */
  static readonly ApiWebUpoTransferHashGetPath = '/api/web/upo/transfer/{hash}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoTransferHashGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransferHashGet$Response(params: ApiWebUpoTransferHashGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoTransferHashGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoTransferHashGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoTransferHashGet(params: ApiWebUpoTransferHashGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoTransferHashGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebUpoWymianaHashGet()` */
  static readonly ApiWebUpoWymianaHashGetPath = '/api/web/upo/wymiana/{hash}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebUpoWymianaHashGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoWymianaHashGet$Response(params: ApiWebUpoWymianaHashGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWebUpoWymianaHashGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebUpoWymianaHashGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebUpoWymianaHashGet(params: ApiWebUpoWymianaHashGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWebUpoWymianaHashGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
